import script from "./SearchResults.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchResults.vue?vue&type=script&setup=true&lang=js"

import "./SearchResults.vue?vue&type=style&index=0&id=4593f738&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4593f738"]])

export default __exports__